module.exports = __webpack_public_path__ + "static/media/main.b537e77b.png";